<div class="rs-panel-flex" data-cy="norton360MyAccountSection">
  <div class="rs-panel-flex-cell rs-bg-grey1 rs-flex rs-flex-dir-col">
    <h2 class="rs-tit5">{{ 'norton360.account.title' | translate }}</h2>
    <p>
      {{ 'norton360.account.description.label' | translate }}
    </p>
    <div class="rs-flex-grow rs-flex rs-flex-bottom">
      <a
        href="{{ 'norton360.account.button.link' | translate }}"
        target="_blank"
        data-tms-event="button-click"
        attr.data-tms-button-zone="{{ 'norton360.account.title' | translate }}"
        attr.data-tms-button-name="{{ 'norton360.account.button.label' | translate }}"
        class="rs-btn"
        data-cy="norton360MyAccountButton"
        >{{ 'norton360.account.button.label' | translate }}</a
      >
    </div>
  </div>
</div>
